import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSession } from "@/lib/api";

const AuthCallback = () => {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/admin/login", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(m[1]);

        // Clean the URL hash so it doesn't leak
        try {
            window.history.replaceState({}, document.title, window.location.pathname);
        } catch (e) {
            /* noop */
        }

        exchangeSession(session_id)
            .then((user) => {
                navigate("/admin", { replace: true, state: { user } });
            })
            .catch((err) => {
                const status = err?.response?.status;
                const detail = err?.response?.data?.detail;
                if (status === 403) {
                    setError(detail || "This Google account is not authorised for the parish admin area.");
                } else if (status === 401) {
                    setError("Your sign-in link expired. Please try again.");
                } else {
                    setError(detail || "Sign-in failed. Please try again.");
                }
            });
    }, [navigate]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center px-4">
            <div className="rounded-2xl border border-maroon-100 bg-white/80 p-8 max-w-md text-center shadow-sm">
                {!error ? (
                    <>
                        <Loader2 size={28} className="mx-auto animate-spin text-maroon-600" />
                        <p className="mt-4 text-maroon-700">Signing you in to the parish admin area…</p>
                    </>
                ) : (
                    <>
                        <p className="font-serif text-xl text-maroon-800">Access denied</p>
                        <div className="gold-divider my-3 opacity-50" />
                        <p className="text-sm text-maroon-700/85">{error}</p>
                        <button
                            type="button"
                            onClick={() => navigate("/admin/login", { replace: true })}
                            className="btn-primary mt-5"
                        >
                            Back to sign in
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthCallback;
